<template>
    <div class="mbadge">
        <div class="mbadgel">
            <div v-if="cpnum" class="info" :style="'background:'+bgcolor">
                    {{cpnum}}
            </div>
            <slot></slot>
        </div>
        <div class="ilblock"></div>
    </div>
</template>
<script>
export default {
   props:{
       num:{
           type:[String,Number],
       },
       bgcolor:{
           type:String,
           default(){
               return "#FF5926"
           }
       }
   },
   computed:{
       cpnum(){
           let num=this.num-0;
           if(num>99) return "99+";
           return num;
       }
   } 
}
</script>
<style lang="scss" scoped>
.mbadge{
    display: inline-block;
    height: 100%;
    .mbadgel{
        display: inline-block;
        position: relative;
        vertical-align: middle;
        .info{
            position: absolute;
            right: 0;
            top: 0;
            transform: translate(50%,-50%);
            border-radius: 50%;
            color: #fff;
            font-size: 60%;
            padding: 2px;
        }
    
    }
    .ilblock{
        display: inline-block;
        vertical-align: middle;
        height: 100%;
    }
}
</style>